import { useField } from '@rocketseat/unform';
import {
  Button,
  Checkbox,
  Dropdown,
  Text,
  TextField,
  WrapperFlex,
} from '@unimed-fesp/components';
import React, { useCallback, useState } from 'react';

import DatePicker from '../../molecules/DatePicker';
import LabelContainer from '../../molecules/LabelContainer';

import {
  CardFilter,
  CardFilterContent,
  CardFilterFooter,
  CardFilterHeader,
  Container,
} from './styles';

function FilterExtendsBeneficiarios({ errorMessages, cleanErrors }) {
  const [selectedFilter, setSelectedFilter] = useState(
    'Modalidade + Termo + Nome'
  );

  const [selectedOption, setSelectedOption] = useState(0);
  const [typeBeneficiary, setTypeBeneficiary] = useState('');
  const [inputModality, setModality] = useState('');
  const [beneficiaryName, setBeneficiaryName] = useState('');
  const [term, setTerm] = useState('');
  const [cpf, setCpf] = useState('');
  const [codeCard, setCodeCard] = useState('');
  const [beneficiaryBirthday, setBeneficiaryBirthday] = useState('');
  const registerModality = useField('modality').registerField;
  const registerTypeForm = useField('typeForm').registerField;
  const registerBeneficiaryName = useField('nameBeneficiary').registerField;
  const registerTerm = useField('termo').registerField;
  const registerTypeBeneficiary = useField('typeBeneficiary').registerField;
  const registerCPF = useField('cpf').registerField;
  const registerCodeCard = useField('codeCard').registerField;

  const optionsFilters = [
    {
      onClickOption: () => handleOptions('Modalidade + Termo + Nome', 0),
      text: 'Modalidade + Termo + Nome',
    },
    {
      onClickOption: () => handleOptions('Codigo do Cartao', 1),
      text: 'Codigo do Cartão',
    },
    {
      onClickOption: () => handleOptions('Nome + Tipo Beneficiario', 2),
      text: 'Nome + Tipo Beneficiario',
    },
    {
      onClickOption: () => handleOptions('Nome + Data Nascimento', 3),
      text: 'Nome + Data Nascimento',
    },
    {
      onClickOption: () => handleOptions('CPF', 4),
      text: 'CPF',
    },
  ];

  const optionsTypeBeneficiary = [
    {
      onClickOption: () => handleTypeBeneficiario('Titular'),
      text: 'Titular',
    },
    {
      onClickOption: () => handleTypeBeneficiario('Dependente'),
      text: 'Dependente',
    },
  ];

  const handleModality = (e) => {
    setModality(e.target.value);
  };
  const handleBeneficiaryName = (e) => {
    setBeneficiaryName(e.target.value);
  };
  const handleTerm = (e) => {
    setTerm(e.target.value);
  };
  const handleCpf = (e) => {
    setCpf(e.target.value);
  };
  const handleCodeCard = (e) => {
    setCodeCard(e.target.value);
  };
  const limparFiltros = () => {
    cleanErrors();
    setTypeBeneficiary('');
    setModality('');
    setBeneficiaryName('');
    setTerm('');
    setCpf('');
    setCodeCard('');
    setBeneficiaryBirthday('');
  };
  const handleOptions = (value, id) => {
    setSelectedFilter(value);
    setSelectedOption(id);
    cleanErrors();
    limparFiltros();
  };
  const handleTypeBeneficiario = (type) => {
    setTypeBeneficiary(type);
  };

  const handleBeneficiaryBirthday = useCallback((data) => {
    if (data.target) return;
    setBeneficiaryBirthday(data);
  }, []);

  return (
    <Container isOpen>
      <CardFilter>
        <CardFilterHeader>Tipo Consulta</CardFilterHeader>
        <CardFilterContent>
          <WrapperFlex flexWrap column justifyStart>
            <Dropdown
              options={optionsFilters}
              tipo="dropdown"
              width={300}
              name="typeForm"
              register={registerTypeForm}
            >
              {selectedFilter}
            </Dropdown>
            {selectedOption === 0 && (
              <WrapperFlex flexWrap justifyStart>
                <TextField
                  name="modality"
                  width={120}
                  height={40}
                  marginBottom={6}
                  labelText="Modalidade"
                  placeholder="Modalidade"
                  font="13px 'Calibri Regular'"
                  register={registerModality}
                  onChange={(e) => {
                    handleModality(e);
                  }}
                  value={inputModality}
                  errorMessage={errorMessages.modality}
                  error={errorMessages.modality}
                />

                <TextField
                  name="term"
                  width={120}
                  height={40}
                  marginBottom={6}
                  labelText="Termo"
                  placeholder="Termo"
                  font="13px 'Calibri Regular'"
                  register={registerTerm}
                  onChange={(e) => {
                    handleTerm(e);
                  }}
                  value={term}
                  errorMessage={errorMessages.term}
                  error={errorMessages.term}
                />
                <TextField
                  name="beneficiaryName"
                  width={400}
                  height={40}
                  marginBottom={6}
                  labelText="Nome do Beneficiario"
                  placeholder="Pesquise pelo nome do Beneficiário"
                  font="13px 'Calibri Regular'"
                  register={registerBeneficiaryName}
                  value={beneficiaryName}
                  onChange={(e) => {
                    handleBeneficiaryName(e);
                  }}
                  type="text"
                />
              </WrapperFlex>
            )}
            {selectedOption === 1 && (
              <WrapperFlex flexWrap justifyStart>
                <TextField
                  name="codigoUnimed"
                  width={100}
                  height={40}
                  marginBottom={6}
                  labelText="Código Unimed"
                  font="13px 'Calibri Regular'"
                  value={'0970'}
                  disabled
                />
                <TextField
                  name="codeCard"
                  width={250}
                  height={40}
                  marginBottom={6}
                  labelText="Código do Cartão"
                  placeholder="Pesquise pelo número do cartão"
                  font="13px 'Calibri Regular'"
                  register={registerCodeCard}
                  value={codeCard}
                  onChange={(e) => {
                    handleCodeCard(e);
                  }}
                  type="number"
                  errorMessage={errorMessages.codeCard}
                  error={errorMessages.codeCard}
                />
              </WrapperFlex>
            )}
            {selectedOption === 2 && (
              <WrapperFlex flexWrap justifyStart>
                <TextField
                  name="beneficiaryName"
                  width={400}
                  height={40}
                  marginBottom={6}
                  labelText="Nome do Beneficiario"
                  placeholder="Pesquise pelo nome do Beneficiário"
                  font="13px 'Calibri Regular'"
                  register={registerBeneficiaryName}
                  onChange={(e) => {
                    handleBeneficiaryName(e);
                  }}
                  value={beneficiaryName}
                  errorMessage={errorMessages.beneficiaryName}
                  error={errorMessages.beneficiaryName}
                />
                <Dropdown
                  options={optionsTypeBeneficiary}
                  tipo="dropdown"
                  width={200}
                  name="typeBeneficiary"
                  height={40}
                  labelText="Selecione um tipo de Beneficiario"
                  register={registerTypeBeneficiary}
                >
                  {typeBeneficiary || 'Titular'}
                </Dropdown>
              </WrapperFlex>
            )}
            {selectedOption === 3 && (
              <WrapperFlex alignStart gap={10}>
                <TextField
                  name="beneficiaryName"
                  width={400}
                  height={40}
                  labelText="Nome do Beneficiario"
                  placeholder="Pesquise pelo nome do Beneficiário"
                  font="13px 'Calibri Regular'"
                  register={registerBeneficiaryName}
                  onChange={(e) => {
                    handleBeneficiaryName(e);
                  }}
                  value={beneficiaryName}
                  type="text"
                  errorMessage={errorMessages.beneficiaryName}
                  error={errorMessages.beneficiaryName}
                />
                <WrapperFlex column marginTop={4}>
                  <Text text={'Data de Nascimento'} />
                  <DatePicker
                    name="beneficiaryBirthday"
                    value={beneficiaryBirthday}
                    onChange={handleBeneficiaryBirthday}
                    required
                  />
                </WrapperFlex>
              </WrapperFlex>
            )}
            {selectedOption === 4 && (
              <WrapperFlex WrapperFlex flexWrap justifyStart>
                <TextField
                  name="cpf"
                  width={300}
                  height={40}
                  marginBottom={6}
                  labelText="CPF"
                  placeholder="Pesquise pelo CPF"
                  font="13px 'Calibri Regular'"
                  register={registerCPF}
                  value={cpf}
                  onChange={(e) => {
                    handleCpf(e);
                  }}
                  errorMessage={errorMessages.cpf}
                  error={errorMessages.cpf}
                />
              </WrapperFlex>
            )}
          </WrapperFlex>
        </CardFilterContent>
        <CardFilterFooter justifyContent="left">
          <Button
            tipo="primary"
            justifyCenter
            alignCenter
            type="submit"
            font="16px unimed_slabregular"
            width={100}
          >
            pesquisar
          </Button>
          <Button
            tipo="secondary"
            justifyCenter
            alignCenter
            type="button"
            onClick={limparFiltros}
            font="16px unimed_slabregular"
            width={100}
          >
            limpar
          </Button>
        </CardFilterFooter>
      </CardFilter>
    </Container>
  );
}

export default FilterExtendsBeneficiarios;
